import useMetaStore from '@/store/useMetaStore';
import { useEffect } from 'react';

/**
 * cdn放入static，通过script标签引入external出去，放入自定义js里的sp中 
 */

export const useJsScript = () => {
  const meta = useMetaStore();
  const { pageConfig } = meta;
  const extraButtonList = (pageConfig)?.freeBtnConfig?.filter(x => x.visible !== false) || [];
  useEffect(() => {
  // 注册基于事件变更的规则
    if (extraButtonList.length) {
      const cdnUrlList = [
        '/static/js/pdf-lib@1.17.1/dist/pdf-lib.min.js',
        '/static/js/@pdf-lib/fontkit@1.1.1/dist/fontkit.umd.min.js',
      ];
      cdnUrlList.forEach((item, index) => {
        if (index === 0 && window.PDFLib) {
          return;
        }
        if (index === 1 && window.fontkit) {
          return;
        }
        const script = document.createElement('script');
        script.src = item;
        document.body.appendChild(script);
      });
    }
  }, [extraButtonList]);
};
